import { SET_ERRORS, SET_TITLE, CLEAR_ERRORS} from '../types'

export const setErrors = (error) => {
  return {
    type: SET_ERRORS,
    payload: error.message,
  }
}

export const clearErrors = (error) => {
  return {
    type: CLEAR_ERRORS,
  }
}

export const setTitle = (title) => {
  return {
    type: SET_TITLE,
    payload: title,
  }
}
